// extracted by mini-css-extract-plugin
export default {"title":"_4ffe3409c3","bld":"_15a38604c7"};